<template>
<div class="tw_documents" :class="{ 'mode_standard': classMode === 'standard' }">
  <tw-collapse :title="$t('Label.Attached Files')" :initialOpen="documents && documents.length > 0" ref="collapse">
    <template v-slot:header-inner>
      <div class="documents-header">
        <div class="documents-header-title">
          <span class="documents_title">{{ $t('Label.Attached Files') }}</span>
          <!-- Download -->
          <el-tooltip placement="top" popper-class="mcu" :tabindex="-1">
            <div slot="content">Download</div>
            <tw-button v-if='downloadableDocuments.length' type='secondary' size='medium' icon='download' @click='downloadSelectedDocuments()' :disabled='selectedDocumentsForDownload.length <= 0' />
          </el-tooltip>
        </div>
        <div class="documents-header-actions" :class="{ compact: isActionsCompact }">
          <!-- Edit Attached Files -->
          <el-button
            v-if='isShowEditAttachedFilesButton'
            size="medium"
            type="button"
            class="tw-button tw-button__secondary"
            @click="onOpenEditAttachedFilesModal"
            :disabled="!(selectedDocumentsForDownload.length <= 0)"
          ><img src="@/assets/images/icons/edit_attached_files.svg" style="width:15px;height:16px;vertical-align:middle;margin-right:8px;">{{ $t('Label.Edit Attached Files') }}</el-button>
          <!-- AI-OCRのステータス更新 -->
          <el-tooltip v-if='hasAiOcrPermitted() && needEditButton && classMode !== "simple"' placement="top" popper-class="mcu" :tabindex="99">
            <div slot="content">Update AI-OCR Status</div>
            <el-button :loading="aiOcrLoading.status" :disabled="!hasActiveAiOcrDocument" icon="el-icon-refresh" size="medium" type="button" class="tw-button tw-button__secondary" @click="handleUpdateStatusBtn()">{{ $t('Label.Update') }}</el-button>
          </el-tooltip>
          <!-- 貿易書類照合 -->
          <el-button
            v-if='hasAiOcrPermitted() && needEditButton && classMode !== "simple"'
            icon="el-icon-document-checked"
            size="medium"
            type="button"
            class="tw-button tw-button__secondary"
            @click="openCrossCheckDialog()"
          >貿易書類照合</el-button>
        </div>
      </div>
    </template>
    <div class="attachment" :class="{ 'simple': classMode === 'simple','standard': classMode === 'standard'}">

      <el-checkbox
        v-if="downloadableDocuments && downloadableDocuments.length > 0"
        :indeterminate="!selectAllcheckboxIsSelected && (selectedDocumentsForDownload.length > 0)"
        v-model="selectAllcheckboxIsSelected">
        {{ $t('Common.Select All') }}
      </el-checkbox>

      <!-- documentsでループ -->
      <div class="file" v-for="(doc, index) in documents" :key="index">
        <div class="user">
          <figure class="avatar table"><img :src="doc.updateUserIcon"></figure>
          <el-tooltip placement="top" popper-class="mcu" :tabindex="-1">
            <div slot="content">{{doc.updateUserName}}</div>
            <div class="from_name">{{doc.updateUserName}}</div>
          </el-tooltip>
        </div>

        <div class="inner">
          <!-- アーカイブ一覧から遷移して表示するアーカイブのプロセス詳細画面では削除済みの添付ファイルは表示される。削除済みの添付ファイルについてはダウンロード不可とするためチェックボックスはなし。 -->
          <div v-if="doc.deleteFlg === DELETE_FLG.DELETED && !doc.documentPath">
            <span class="file_name">{{doc.documentName}}</span>
          </div>
          <div v-else>
            <div style="display: flex; align-items: flex-start;">
              <el-checkbox style="display: flex; flex: 1; min-width: 0;" v-model="selectedDocumentsForDownload" :label="doc">
                <span class="file_name">{{doc.documentName}}</span>
              </el-checkbox>
              <!-- PDF Previewアイコン: AI-OCRボタンがない場合はファイル名横に表示 -->
              <template v-if="doc.deleteFlg !== DELETE_FLG.DELETED && doc.documentPath && s.isPdf(doc) && !(useAiOcr(doc) && !aiOcrLoading.status && classMode !== 'simple')">
                <el-tooltip placement="top" popper-class="mcu" :tabindex="-1">
                  <div slot="content">PDF Preview（⌘/Ctrl＋クリックで別タブ）</div>
                  <img @click="s.onPreviewPdfClick(doc, $event)" style="cursor:pointer; flex-shrink:0; margin-left:4px;"
                       src="@/assets/images/icons/icon_pdf_preview.svg">
                </el-tooltip>
                <el-tooltip placement="top" popper-class="mcu" :tabindex="-1">
                  <div slot="content">Open in New Tab</div>
                  <!-- ★width:25px でプレビューアイコン（25×25）と大きさを揃える -->
                  <img @click="s.previewPdfNewTab(doc)" style="cursor:pointer; flex-shrink:0; margin-left:4px; width:25px;"
                       src="@/assets/images/icons/icon_external_link.svg">
                </el-tooltip>
              </template>
            </div>
            <!-- file-actions: AI-OCRボタンがある場合 (AI-OCRボタン → PDF Previewアイコンの順) -->
            <div v-if="doc.deleteFlg !== DELETE_FLG.DELETED && doc.documentPath && s.isPdf(doc) && useAiOcr(doc) && !aiOcrLoading.status && classMode !== 'simple'" class="file-actions">
              <div class="file-actions-buttons">
                <el-button
                  :disabled="hasInvalidStatus(doc)"
                  :loading="aiOcrLoading.start"
                  size="mini"
                  v-bind="btnPropsByAiOcrStatus(doc)"
                  @click="handleAiOcrActions(doc)"
                >{{ btnTextByAiOcrStatus(doc) }}</el-button>
                <el-tag
                  v-if="doc.aiOcrStatus === 5 && !isSaveCompletedIds.includes(doc.documentManageId)"
                  type="success"
                  effect="plain"
                >反映済み</el-tag>
              </div>
              <el-tooltip placement="top" popper-class="mcu" :tabindex="-1">
                <div slot="content">PDF Preview（⌘/Ctrl＋クリックで別タブ）</div>
                <img @click="s.onPreviewPdfClick(doc, $event)" style="cursor:pointer;" src="@/assets/images/icons/icon_pdf_preview.svg">
              </el-tooltip>
              <el-tooltip placement="top" popper-class="mcu" :tabindex="-1">
                <div slot="content">Open in New Tab</div>
                <!-- ★width:25px でプレビューアイコン（25×25）と大きさを揃える -->
                <img @click="s.previewPdfNewTab(doc)" style="cursor:pointer; width:25px;" src="@/assets/images/icons/icon_external_link.svg">
              </el-tooltip>
            </div>
          </div>
          <div style="display: flex;justify-content:space-between;align-items:center;padding-bottom: 8px">
            {{doc.updateDate | dateTimeFormat}},&nbsp;{{doc.documentSize | fileSize}}
          </div>
          <div>
            <template v-for="(item, index) in DOCUMENT_LINK_VARIABLES">
              <el-tag v-if="doc['documentLink' + getDocumentKey(item.code)] === ATTACHED_FILE_FLG.ON" :key="index" type="info" class="file-category-tag">
                <el-tooltip v-if="/^Others\d+/.test(item.label) && doc['documentLinkLabel' + getDocumentKey(item.code)]" placement="top" popper-class="mcu">
                  <div slot="content">{{doc['documentLinkLabel' + getDocumentKey(item.code)]}}</div>
                  <span>{{ item.label }}</span>
                </el-tooltip>
                <span v-else>{{ item.label }}</span>
              </el-tag>
            </template>
          </div>
          <div v-if="doc.documentCommentText" class="comment"  v-html="sanitize(doc.documentCommentText)" />
        </div>
      </div>

      <!-- documentsが空の場合 -->
      <div v-if="!documents.length" class="empty_message">{{$t('Message.NoResult1')}}</div>
    </div>
  </tw-collapse>


  <el-dialog v-show='s.pdfSrc === null && this.isShowEditAttachedFilesModal == true'
              title='Edit Attached Files'
             :visible.sync='isShowEditAttachedFilesModal'
             :close-on-click-modal='false'
             :before-close='closeEditAttachedFilesModal'
             :class="{'header_border': s.pdfSrc === null, 'hide-modal': s.pdfSrc !== null}"
             width='944px'
             aria-label='Select Customer'
             :append-to-body='true'
  >
    <tw-edit-attached-files-section ref='twEditAttachedFilesSection'
                                    @onSuccess='disableEditAttachedFilesModal'
                                    @update-attached-files="updateAttachedFiles"
                                    @save="(action, documents) => $emit('save', action, documents)"
                                    @approval-request="onApprovalRequest"
    />

  </el-dialog>

  <!-- AI-OCR結果確認とマッピングのダイアログ -->
  <el-dialog
    custom-class="dialog-aiOcr"
    :visible.sync="isShowDialogAiOcr"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closeDialogAiOcr"
    width="94%"
    top="3vh"
  >
    <template #title>
      <div class="flex align-end">
        <div class="flex-grow pt-2">
          <div class="text-24 text-bold mb-2">
            AI-OCR 読取結果
          </div>
          <div class="text-14 text-gray-800">
            PDFファイルの読取結果から取り込む内容を調整して保存できます。読取りに成功した項目のみ値を表示しています。
          </div>
        </div>
        <div>
          <el-button type="plain" @click="handleAiOcrTsvDownload">
            TSV Download
          </el-button>
          <el-button type="primary" @click="handleSave">
            Save
          </el-button>
          <el-button @click="closeDialogAiOcr">
            Cancel
          </el-button>
        </div>
      </div>
    </template>
    <MapAiOcr
      v-if="isShowDialogAiOcr"
      :payload="selectedAiOcrPayload"
      :validationCheck="aiOcrValidationCheck"
      :processType="s.processType"
      @click="closeDialogAiOcr"
      @updateDetailData="handleUpdateOcrData"
      @changeTab="handleAiOcrChangeTab"
    />
  </el-dialog>

  <!-- 帳票間チェックダイアログ -->
  <CrossCheckAiOcr
    :visible="isShowDialogCrossCheck"
    :tradingId="s.res.tradeManagement.tradingId"
    :tradingFlowId="s.res.tradeManagement.tradingFlowId"
    @update:visible="isShowDialogCrossCheck = $event"
    @close="isShowDialogCrossCheck = false"
    @save="(action, documents) => $emit('save', action, documents)"
  />
</div>
</template>

<script>
import _ from 'lodash';
import {
  DELETE_FLG,
  PROCESS_TYPE,
  CO_DOCUMENT_ID_VARIABLES,
  PROCESS_PROGRESS_STATUS,
  DOCUMENT_LINK_VARIABLES,
  ATTACHED_FILE_FLG,
  EDITABLE_FLG
} from 'lib-tw-common';
import { $api } from '@/store/ApiClient';

// mixin
import aiOcrMixin from '@/utils/mixinTwDocumentsAiOcr'

import TwButton from '@/components/atoms/TwButton';
import TwCollapse from '@/components/molecules/TwCollapse';

import MapAiOcr from '@/views/vue3/process/components/mapAiOcr.vue';
import CrossCheckAiOcr from '@/views/vue3/process/components/crossCheckAiOcr.vue';

import TwEditAttachedFilesSection from './TwEditAttachedFilesSection.vue';

export default {
  name: 'TwDocuments',
  inject: ['s', 'hasAiOcrPermitted'],
  mixins: [aiOcrMixin],
  props: {
    items: Object,
    classMode: String
  },
  components: {
    TwButton,
    TwCollapse,
    TwEditAttachedFilesSection,
    MapAiOcr,
    CrossCheckAiOcr,
  },
  data() {
    return {
      DELETE_FLG,
      ATTACHED_FILE_FLG,
      DOCUMENT_LINK_VARIABLES,
      isShowEditAttachedFilesModal: false,
      isShowDialogCrossCheck: false,
      entityId: this.entityId,
      processId: this.processId,
      processSeq: this.processSeq,
      selectedDocumentsForDownload: [],
      isActionsCompact: false,
    };
  },
  mounted() {
    this.$nextTick(() => this._checkCompact());
    if (typeof ResizeObserver !== 'undefined') {
      this._lastWidth = 0;
      this._resizeObserver = new ResizeObserver(entries => {
        const width = entries[0]?.contentRect.width || this.$el.offsetWidth;
        const isGrowing = width > this._lastWidth;
        this._lastWidth = width;
        if (isGrowing) {
          this.isActionsCompact = false;
          this.$nextTick(() => this._checkCompact());
        } else if (!this.isActionsCompact) {
          this.$nextTick(() => this._checkCompact());
        }
      });
      this._resizeObserver.observe(this.$el);
    }
  },
  beforeDestroy() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  },
  computed: {
    documents() {
      const docs = _.get(this, 's.res.documents');
      const list = Array.isArray(docs) ? docs : [];
      return list.map(doc => {

        // ステータス取得BFFからの返り値が入るmixinのaiOcrStatusListに同じドキュメントIDがあるかどうかで
        // documentの情報を調整
        const aiOcrStatus = _.find(this.aiOcrStatusList, {
          documentManageId: doc.documentManageId,
        });

        return {
          ...doc,
          aiOcrStatus: aiOcrStatus?.twOcrStatus || 0,
          aiOcrTrx: aiOcrStatus?.documentTrx,
        };
      });
    },
    downloadableDocuments() {
      // 削除済みの添付ファイルは含まれない。最新のプロセス詳細画面では削除済みの添付ファイルは表示されない。
      return _.reject(this.documents, doc => {
        return doc.deleteFlg === DELETE_FLG.DELETED && !doc.documentPath;
      });
    },
    selectAllcheckboxIsSelected: {
      get() {
        return (this.selectedDocumentsForDownload.length === this.downloadableDocuments.length);
      },
      set(value) {
        if (value) {
          this.selectedDocumentsForDownload = this.downloadableDocuments;
        } else {
          this.selectedDocumentsForDownload = [];
        }
      }
    },
    sanitize() {
      return string => {
        const documentId = _.find(CO_DOCUMENT_ID_VARIABLES, {code: string})
        if ((this.s.processType === PROCESS_TYPE.FDCOR || this.s.processType === PROCESS_TYPE.FDCOI) && documentId) {
          string = documentId.label;
        }
        return this.$sanitize(string).replace(/\n/g, '<br>');
      }
    },
    isShowEditAttachedFilesButton() {
      if (
        this.s.processType !== PROCESS_TYPE.COPO
        && this.s.processType !== PROCESS_TYPE.COCOS
        && this.s.processType !== PROCESS_TYPE.TPATPRB // 「船積準備」エンティティの「船積・出荷準備」プロセス、「輸送」エンティティの「Booking依頼」プロセスの2つ
        && this.s.processType !== PROCESS_TYPE.ECREQ
        && this.s.processType !== PROCESS_TYPE.FDDOC
        && this.s.processType !== PROCESS_TYPE.ICREQ
      ) {
        return false;
      }

      if (this.s.tradeManagement.processProgressStatus === PROCESS_PROGRESS_STATUS.NOT_STARTED) {
        if(this.s.tradeManagement.editAbleFlg !== EDITABLE_FLG.ON) return false;
        if (!this.$store.getters.isPic) return false;
        if (this.s.isArchive) return false;
        return true;
      }

      if (
        this.s.tradeManagement.processProgressStatus !== PROCESS_PROGRESS_STATUS.F_INPUT_IN_PROGRESS
        && this.s.tradeManagement.processProgressStatus !== PROCESS_PROGRESS_STATUS.T_AWAITING_CONFIRMATION
        ) {
        return false;
      }

      if (!this.$store.getters.isPic) {
        return false;
      }

      if (this.s.isArchive) {
        return false;
      }

      return true;
    },
  },
  created() {
    this.localResData = _.cloneDeep(this.s.res);
    if (this.hasAiOcrPermitted() && this.s.res.documents.length > 0 && this.needEditButton) {
      // 各PDFドキュメントのAI-OCRステータスを取得
      this.getAiOcrStatus();
    }
  },
  watch: {
    documents(val) {
      if (val && val.length > 0) {
        this.$refs.collapse.open = true;
      }
    }
  },
  methods: {
    camelCase(str) {
      return str.replace(/_([a-z])/g, (_, c) => c.toUpperCase())
    },
    download(doc) {
      const path = {
        documentManageId: doc.documentManageId,
        documentTrx: doc.documentTrx
      };

      $api
        .download(path, doc.documentName)
        .then(() => {
        })
        .catch(err => {
          this.$store.dispatch('SHOW_ALERT', err.message);
        });
    },
    downloadSelectedDocuments() {
      this.$store
        .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__FILE_DOWNLOAD'))
        .then(async () => {
          for(const doc of this.selectedDocumentsForDownload) {
            await new Promise((resolve) => {
              setTimeout(() => {
                this.download(doc);
                resolve();
              }, 1000)
            })
          }
          this.selectedDocumentsForDownload = [];
        })
        .catch(() => {});
    },
    onOpenEditAttachedFilesModal() {
      this.isShowEditAttachedFilesModal = true;
      this.$nextTick(() => {
        if (this.$refs.twEditAttachedFilesSection) this.$refs.twEditAttachedFilesSection.fetchUploadedFiles();
      });
    },
    closeEditAttachedFilesModal(done) {
      this.$nextTick(() => {
        // モーダル上でファイル操作（添付・削除・コメント修正）をしていなければ、ポップアップを出さずにモーダルを閉じる
        if (
          this.$refs.twEditAttachedFilesSection &&
          !this.$refs.twEditAttachedFilesSection.fileActionOccurred
        ) {
          this.$refs.twEditAttachedFilesSection.resetDialog();
          done();
          return;
        }

        // モーダル上でファイル操作をしていれば、モーダルを閉じる際にポップアップを表示する
        this.$store
        .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__NAVIGATION_WITH_UNSAVED_DATA'))
          .then(() => {
            if (this.$refs.twEditAttachedFilesSection) {
              this.$refs.twEditAttachedFilesSection.resetDialog();
            }
            done();
          })
          .catch(() => {});
      });
    },
    updateAttachedFiles() {
      this.$emit('update-attached-files');
    },
    disableEditAttachedFilesModal() {
      this.isShowEditAttachedFilesModal = false;
      this.$nextTick(() => {
        if (this.$refs.twEditAttachedFilesSection)
          this.$refs.twEditAttachedFilesSection.resetDialog();
      });
    },
    onApprovalRequest(action, documents) {
      this.disableEditAttachedFilesModal();
      this.$emit('approval-request', action, documents);
    },
    getDocumentKey(code) {
      const Key = {
        1: "Inv",
        2: "Pl",
        3: "Bl",
        4: "An",
        5: "Si",
        6: "Co",
        7: "Others1",
        8: "Others2",
        9: "Others3",
        10: "Others4",
        11: "Others5",
        12: "Contract",
        13: "Dn",
        14: "Po",
      };
      return Key[code] || "";
    },
    openCrossCheckDialog() {
      this.isShowDialogCrossCheck = true;
    },
    _checkCompact() {
      const actions = this.$el.querySelector('.documents-header-actions');
      if (!actions) return;
      const children = Array.from(actions.children);
      if (children.length < 2) return;
      const firstTop = children[0].getBoundingClientRect().top;
      const hasWrapped = children.some(el => el.getBoundingClientRect().top > firstTop + 4);
      if (hasWrapped) {
        this.isActionsCompact = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tw_documents {
  position: relative;
  margin-bottom: 16px;

  .attachment.simple,.attachment.standard {
    max-height: calc(100vh - 320px) !important;
  }
  .attachment {
    max-height: 410px;
    overflow-y: auto;
    padding: 4px 16px 27px;
    font-size: 14px;
    line-height: 20px;

    .file {
      .user {
        display: flex;
        align-items: center;
        margin-top: 8px;
        margin-bottom: 4px;

        font-size: 12px;
        line-height: 20px;
        color: $color_black;

        .from_name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .inner {
        width: 100%;
        min-height: 55px;
        margin-top: 8px;
        padding: 8px 8px 0 16px;
        border-radius: 6px;
        background: $color_gray_100;
      }

      span.file_name {
        display: block;
        margin-right: 10px;
        text-decoration: none;
        font-size: 14px;
        text-wrap: wrap;
        line-height: 1.2;
      }

      .file-actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        flex-wrap: nowrap;
        margin-top: 4px;

        .file-actions-buttons {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
        }
      }

      .comment {
        margin-top: 8px;
        padding-bottom: 8px;
      }
    }
  }
}

.empty_message {
  font-weight: 500;
  font-size: 20px;
  line-height: 27px;
  color: $color_black;
  margin-top: 33px;
  margin-bottom: 0px;
}

.documents-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.documents-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.documents_title {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
}

.documents-header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;

  .el-button, .tw_button {
    margin-left: 0 !important;
  }

  &.compact .el-button {
    font-size: 12px !important;
    padding: 4px 10px !important;
    height: auto !important;
    line-height: 1.4 !important;

    img {
      width: 12px !important;
      height: 13px !important;
      margin-right: 5px !important;
    }
  }
}

.mode_standard {
  .inner .el-button--mini {
    white-space: normal;
    word-break: break-all;
    height: auto;
    line-height: 1.4;
    padding: 4px 6px;
  }

  .file-actions {
    .file-actions-buttons {
      flex-wrap: wrap;
    }
  }
}
.file-category-tag {
  margin-right: 5px;
  align-items: center;
  text-align: center;
  height: auto;
  color: #333;
  border-color: #d3d4d6;
}

::v-deep .dialog-aiOcr .el-dialog__body {
  padding: 0;
}
</style>

<style lang='scss'>
.icon-refresh {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 28px;
  height: 28px;
}

.dialog-aiOcr {
  height: 92vh;
  display: flex;
  flex-direction: column;
}

div.el-dialog__wrapper.hide-modal ~ div.v-modal {
  display: none;
}
.v-modal:has(~ .hide-modal) {
  display: none;
}
.blink {
  animation: blink-bg 2s infinite;
}
@keyframes blink-bg {
  0% {
    background-color: yellow;
  }
  50% {
    background-color: transparent;
  }
  100% {
    background-color: yellow;
  }
}

/* ダイアログ自体を固定高にして内部を flex 伸縮 */
.dialog-aiOcr .el-dialog {
  display: flex;
  flex-direction: column;
}
.dialog-aiOcr .el-dialog__body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 0 20px;
}
</style>
